/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 * http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

import _ from 'lodash';
import React from 'react';
import { decorate, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Segment, Icon, Header, Table } from 'semantic-ui-react';

import ScEnvironmentOdbcConnectionRow from './ScEnvironmentOdbcConnectionRow';

// expected props
// - environment (via prop)
class ScEnvironmentOdbcConnections extends React.Component {
  get environment() {
    return this.props.scEnvironment;
  }

  // Returns only the connections that scheme = 'odbc'
  // [ {id, name: <string>(optional), instanceId: <string>, scheme: 'odbc'}, ... ]
  get connections() {
    const connections = this.environment.getConnections(item => item.scheme === 'odbc');

    return connections;
  }

  render() {
    const env = this.environment;
    const state = env.state;
    const canConnect = state.canConnect;
    const empty = _.isEmpty(this.connections);

    if (!canConnect) return null;
    let content = null;

    if (empty) {
      content = this.renderEmpty();
    } else {
      content = this.renderConnections();
    }

    return <div className="fadeIn animated">{content}</div>;
  }

  renderConnections() {
    const env = this.environment;
    const connections = this.connections;

    return (
      <div className="mt2 mb2 fadeIn animated">
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="1">ODBC Connections</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {_.map(connections, item => (
              <ScEnvironmentOdbcConnectionRow key={item.id} scEnvironment={env} connectionId={item.id} />
            ))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  renderEmpty() {
    return (
      <Segment placeholder className="mt2 mb2">
        <Header icon className="color-grey">
          <Icon name="linkify" />
          No ODBC Connections
          <Header.Subheader>This workspace does not have any defined ODBC connections.</Header.Subheader>
        </Header>
      </Segment>
    );
  }
}

// see https://medium.com/@mweststrate/mobx-4-better-simpler-faster-smaller-c1fbc08008da
decorate(ScEnvironmentOdbcConnections, {
  environment: computed,
  connections: computed,
});

export default inject()(withRouter(observer(ScEnvironmentOdbcConnections)));
